/**
 * @generated SignedSource<<be2c14490f80e18de72a00b37621456a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeAction$data = {
  readonly approvedMetaAdCount: number;
  readonly draftMetaAdCount: number;
  readonly id: string;
  readonly " $fragmentType": "HomeAction";
};
export type HomeAction$key = {
  readonly " $data"?: HomeAction$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomeAction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomeAction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "draftMetaAdCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approvedMetaAdCount",
      "storageKey": null
    }
  ],
  "type": "Brand",
  "abstractKey": null
};

(node as any).hash = "36c1b0ec7cac9e6fa4da101c36bcc745";

export default node;
